export const API_KEYS_SETTINGS_NO_ACCESS_TOOLTIP =
  "Only organization admins can change API key settings.";

export const PERSONAL_API_KEYS_LOGIN_POLICY_TOOLTIP =
  "Requires Identity Access Management. Your organization uses a login policy.";
